import { render, staticRenderFns } from "./score-other.vue?vue&type=template&id=077670c5&scoped=true"
import script from "./score-other.vue?vue&type=script&lang=js"
export * from "./score-other.vue?vue&type=script&lang=js"
import style0 from "./score-other.vue?vue&type=style&index=0&id=077670c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077670c5",
  null
  
)

export default component.exports